import {
  TColumns,
  TFilters,
  TInitialFilters,
  TTabs,
  TTabsNames,
} from 'app/components/MainTableMultiTabs/types';
import AvatarCell from 'app/components/Tables/Cells/AvatarCell';
import NumberOfPosts from 'app/components/Tables/Cells/NumberOfPosts';
import { _t } from 'app/utils/i18n';
import { nFormatter } from 'app/utils/numbersFormater';
import React, { MutableRefObject } from 'react';
import { influencerApiRoutes } from 'influencers/utils/apiRoutes';
import {
  DateFrom,
  DateTo,
  PlatformIcon,
  SearchIcon,
} from 'app/assets/images/icons';
import { checkTranslated, handleFilterMainTable } from 'app/utils/helpers';
import { dateTimeFormatter } from 'app/utils/dateTimeFormatter';
import { path } from 'app/utils/path';
import { Link } from 'react-router-dom';
import PopperComponent from 'app/components/Tables/Cells/PopperComponent/PopperComponent';
import ActionsCell from 'app/components/Tables/Cells/ActionsCell';
import ItemPopperCell from 'app/components/Tables/Cells/ItemPoperCell';
import { renderPlatformIcon } from 'app/utils/renderPlatformIcon';

export const getInfluencerRelatedInfluencers = (
  influencer_id: number,
  isReport: boolean,
  platformsOptions?: unknown[],
  relationOptions?: unknown[],
  tableRef?: MutableRefObject<any>,
  selectInputPlatformsRef?: MutableRefObject<undefined>,
  selectInputRelationRef?: MutableRefObject<undefined>,
  unlinkRelativeInfluencerAction?: (
    id: string | number,
    influencer_id: string | number,
    successMessage: string,
  ) => void | Promise<any>,
  unlinkFriendInfluencerAction?: (
    id: string | number,
    influencer_id: string | number,
    successMessage: string,
  ) => void | Promise<any>,
): {
  tabsNames: TTabsNames;
  tabs: TTabs[];
  coworkersColumns: TColumns[];
  friendsColumns: TColumns[];
  relativesColumns: TColumns[];
  mentionsColumns: TColumns[];
  allColumns: TColumns[];
  fellowStudents: TColumns[];
} => {
  relationOptions = relationOptions?.filter(
    (item: any) => item?.key !== 'WORKPLACE' && item?.key !== 'STUDY_PLACE',
  );
  const allFiltersInputs: TFilters[] = [
    {
      name: 'influencer_name',
      type: 'autocomplete',
      moduleName: influencerApiRoutes().allRelatedInfluencers.slice(0, -1),
      icon: <SearchIcon />,
      placeholder: _t('basic:search_by_inf'),
      customFilters: { influencer_id },
      size: 'large',
      keyExtractor: 'label',
      additionalExtractor: 'id',
      additionalName: 'influencer_id',
    },
    {
      name: 'platform_ids',
      type: 'select',
      icon: <PlatformIcon />,
      placeholder: _t('basic:platform'),
      options: platformsOptions,
      isMulti: true,
      size: 'medium',
      ref: selectInputPlatformsRef,
    },
    {
      name: 'relation_ids',
      type: 'select',
      placeholder: _t('basic:relation_type'),
      options: relationOptions,
      isMulti: true,
      size: 'medium',
      ref: selectInputRelationRef,
    },
  ];

  const relativesFiltersInputs: TFilters[] = [
    {
      name: 'influencer_name',
      type: 'autocomplete',
      moduleName: influencerApiRoutes().relativesRelatedInfluencers,
      icon: <SearchIcon />,
      placeholder: _t('basic:search_by_inf'),
      customFilters: { influencer_id },
      size: 'large',
      keyExtractor: 'label',
      additionalExtractor: 'id',
      additionalName: 'influencer_id',
    },
  ];

  const friendsFiltersInputs: TFilters[] = [
    {
      name: 'influencer_name',
      type: 'autocomplete',
      moduleName: influencerApiRoutes().friendsRelatedInfluencers,
      icon: <SearchIcon />,
      placeholder: _t('basic:search_by_inf'),
      customFilters: { influencer_id },
      size: 'large',
      keyExtractor: 'label',
      additionalExtractor: 'id',
      additionalName: 'influencer_id',
    },
  ];

  const coworkersFiltersInputs: TFilters[] = [
    {
      name: 'influencer_name',
      type: 'autocomplete',
      moduleName: influencerApiRoutes().coworkersRelatedInfluencers,
      icon: <SearchIcon />,
      placeholder: _t('basic:search_by_inf'),
      customFilters: { influencer_id },
      size: 'large',
      keyExtractor: 'label',
      additionalExtractor: 'id',
      additionalName: 'influencer_id',
    },
    {
      name: 'organization_name',
      type: 'autocomplete',
      moduleName: influencerApiRoutes().organizationAutoComplete,
      customFilters: { influencer_id },
      icon: <SearchIcon />,
      placeholder: _t('basic:search_by_workplace'),
      size: 'large',
      keyExtractor: 'label',
      additionalExtractor: 'id',
      additionalName: 'organization_id',
    },
  ];
  const fellowStudentsFiltersInputs: TFilters[] = [
    {
      name: 'influencer_name',
      type: 'autocomplete',
      moduleName: influencerApiRoutes().fellowStudentsAutoComplete,
      icon: <SearchIcon />,
      placeholder: _t('basic:search_by_inf'),
      customFilters: { influencer_id },
      size: 'large',
      keyExtractor: 'label',
      additionalExtractor: 'id',
      additionalName: 'influencer_id',
    },
    {
      name: 'organization_name',
      type: 'autocomplete',
      moduleName: influencerApiRoutes().organizationAutoComplete,
      customFilters: { influencer_id },
      icon: <SearchIcon />,
      placeholder: _t('basic:search_by_organization'),
      size: 'large',
      keyExtractor: 'label',
      additionalExtractor: 'id',
      additionalName: 'organization_id',
    },
  ];

  const mentionsFiltersInputs: TFilters[] = [
    {
      name: 'influencer_name',
      type: 'autocomplete',
      moduleName: influencerApiRoutes().mentionsRelatedInfluencers,
      icon: <SearchIcon />,
      placeholder: _t('basic:search_by_inf'),
      customFilters: { influencer_id },
      size: 'large',
      keyExtractor: 'label',
      additionalExtractor: 'id',
      additionalName: 'influencer_id',
    },
    ...allFiltersInputs.slice(1, 2),
    {
      name: 'start_date',
      type: 'datepicker',
      icon: <DateFrom />,
      placeholder: _t('basic:from'),
      size: 'small',
    },
    {
      name: 'end_date',
      type: 'datepicker',
      icon: <DateTo />,
      placeholder: _t('basic:to'),
      size: 'small',
    },
  ];

  const commonColumns: TColumns[] = [
    {
      name: 'name',
      header: _t('basic:influencer'),
      sortable: isReport ? false : true,
      render: ({ data }: any) => (
        <div className="actionsCell">
          <AvatarCell
            text={checkTranslated(data?.name?.original, data?.name?.arabic)}
            img={data?.image_url}
            rounded
            goTo={
              isReport
                ? undefined
                : data?.status === 'ANALYZED'
                  ? `${path.influencers.ANALYZED_INFLUENCER_DETAILS_URI}/${data?.id}`
                  : `${path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI}/${data?.id}`
            }
          />
        </div>
      ),
    },
    {
      name: 'tweet_count',
      header: _t('basic:mentions'),
      sortable: isReport ? false : true,
      type: 'number',
      render: ({ data }: any) => (
        <div className="followers_count">
          {data?.followers_count > 0 ? nFormatter(data?.mentions) : '_'}
        </div>
      ),
    },
    {
      name: 'relation',
      header: _t('basic:relation_type'),
      render: ({ data }: any) => (
        <div
          className="actionsCell cursor-pointer"
          onClick={() =>
            handleFilterMainTable(
              tableRef,
              'relation_ids',
              data?.relations?.map((item: any) => ({
                label: checkTranslated(
                  item?.relation?.name,
                  item?.relation?.name_ar,
                ),
                value: item?.relation?.relation_id,
              })),
              selectInputRelationRef,
            )
          }
        >
          {data?.relations?.length > 0 ? (
            data?.relations?.length === 1 ? (
              <p key={data?.id}>
                {checkTranslated(
                  data?.relations?.[0]?.relation?.name,
                  data?.relations?.[0]?.relation?.name_ar,
                ).length > 0
                  ? checkTranslated(
                      data?.relations?.[0]?.relation?.name,
                      data?.relations?.[0]?.relation?.name_ar,
                    )
                  : '-'}
                {data?.relations?.[0]?.sub_relation?.name?.length
                  ? ` ( ${checkTranslated(
                      data?.relations?.[0]?.sub_relation?.name,
                      data?.relations?.[0]?.sub_relation?.name_ar,
                    )} )`
                  : ''}
              </p>
            ) : isReport ? (
              <div className="flex-center-gap-10">
                <div>
                  {data?.relations.map((item: any) => (
                    <p key={item?.id}>
                      {checkTranslated(
                        item?.relation?.name,
                        item?.relation?.name_ar,
                      )}
                    </p>
                  ))}
                </div>
                <div>
                  {data?.relations.map((item: any) => (
                    <p key={item?.id}>
                      {checkTranslated(
                        item?.sub_relation?.name,
                        item?.sub_relation?.name_ar,
                      ).length > 0
                        ? checkTranslated(
                            item?.sub_relation?.name,
                            item?.sub_relation?.name_ar,
                          )
                        : '-'}
                    </p>
                  ))}
                </div>
              </div>
            ) : (
              <PopperComponent noMargin>
                <div className="flex-center-gap-30">
                  <div className="gap-5">
                    <h4>{_t('influencers:relation_type')}</h4>
                    {data?.relations.map((item: any) => (
                      <p key={item?.id}>
                        {checkTranslated(
                          item?.relation?.name,
                          item?.relation?.name_ar,
                        )}
                      </p>
                    ))}
                  </div>
                  <div className="gap-5">
                    <h4>{_t('influencers:relation')}</h4>
                    {data?.relations.map((item: any) => (
                      <p key={item?.id}>
                        {checkTranslated(
                          item?.sub_relation?.name,
                          item?.sub_relation?.name_ar,
                        ).length > 0
                          ? checkTranslated(
                              item?.sub_relation?.name,
                              item?.sub_relation?.name_ar,
                            )
                          : '-'}
                      </p>
                    ))}
                  </div>
                </div>
              </PopperComponent>
            )
          ) : (
            <>-</>
          )}
        </div>
      ),
    },
    {
      name: 'followers_count',
      header: _t('basic:followers'),
      sortable: isReport ? false : true,
      type: 'number',
      render: ({ data }: any) => (
        <div className="followers_count">
          {data?.followers_count > 0 ? nFormatter(data?.followers_count) : '_'}
        </div>
      ),
    },
    {
      name: 'platforms',
      header: _t('influencers:platforms'),
      render: ({ data }: any) =>
        isReport ? (
          <div className="flex-icons">
            {data?.platforms?.map((item: { name: string }) =>
              renderPlatformIcon(item?.name, true),
            )}
          </div>
        ) : (
          <div
            className="influencer_platform cursor-pointer"
            onClick={() =>
              handleFilterMainTable(
                tableRef,
                'platform_ids',
                data?.platforms?.map((item: any) => ({
                  label: item?.name,
                  value: item?.id,
                })),
                selectInputPlatformsRef,
              )
            }
          >
            <NumberOfPosts hideText data={data?.platforms} />
          </div>
        ),
    },
    {
      name: 'last_tweet_time',
      header: _t('influencers:last_mentioned_on'),
      sortable: isReport ? false : true,
      render: ({ data }: any) => (
        <p className="createdOn">
          {dateTimeFormatter.date(data?.last_mention_on)}
        </p>
      ),
    },
  ];

  const allColumns: TColumns[] = [
    ...commonColumns.slice(0, 1),
    ...commonColumns.slice(2, 5),
  ];

  const relativesColumns: TColumns[] = [
    {
      name: 'name',
      header: _t('basic:influencer'),
      sortable: isReport ? false : true,
      render: ({ data }: any) => (
        <div className="actionsCell">
          <AvatarCell
            text={checkTranslated(data?.name?.original, data?.name?.arabic)}
            img={data?.image_url}
            rounded
            goTo={
              isReport
                ? undefined
                : data?.status === 'ANALYZED'
                  ? `${path.influencers.ANALYZED_INFLUENCER_DETAILS_URI}/${data?.id}`
                  : `${path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI}/${data?.id}`
            }
          />
          {isReport ? (
            <></>
          ) : (
            <div className="actions">
              <ActionsCell
                hideChart
                rowData={data}
                hideBookmark
                unlinkAction={{
                  runAction: unlinkRelativeInfluencerAction,
                  cb: tableRef?.current?.loadData,
                }}
              />
            </div>
          )}
        </div>
      ),
    },
    {
      name: 'relation',
      header: _t('basic:relation'),
      render: ({ data }: any) => (
        <div className="actionsCell">
          {data?.relations?.length > 0 ? (
            <div className="gap-5">
              {data?.relations?.[0]?.sub_relation?.name !== 0
                ? checkTranslated(
                    data?.relations?.[0]?.sub_relation?.name,
                    data?.relations?.[0]?.sub_relation?.name_ar,
                  )
                : ''}
            </div>
          ) : (
            <>-</>
          )}
        </div>
      ),
    },
    ...commonColumns.slice(3, 4),
  ];

  const friendsColumns: TColumns[] = [
    {
      name: 'name',
      header: _t('basic:influencer'),
      sortable: isReport ? false : true,
      render: ({ data }: any) => (
        <div className="actionsCell">
          <AvatarCell
            text={checkTranslated(data?.name?.original, data?.name?.arabic)}
            img={data?.image_url}
            rounded
            goTo={
              isReport
                ? undefined
                : data?.status === 'ANALYZED'
                  ? `${path.influencers.ANALYZED_INFLUENCER_DETAILS_URI}/${data?.id}`
                  : `${path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI}/${data?.id}`
            }
          />
          {isReport ? (
            <></>
          ) : (
            <div className="actions">
              <ActionsCell
                hideChart
                rowData={data}
                hideBookmark
                unlinkAction={{
                  runAction: unlinkFriendInfluencerAction,
                  cb: tableRef?.current?.loadData,
                }}
              />
            </div>
          )}
        </div>
      ),
    },
    ...commonColumns.slice(3, 4),
  ];

  const coworkersColumns: TColumns[] = [
    ...commonColumns.slice(0, 1),
    {
      name: 'workplace',
      header: _t('influencers:workplace'),
      defaultFlex: 2,
      render: ({ data }: any) => (
        <div className="actionsCell">
          {isReport ? (
            <div>
              {checkTranslated(
                data?.workplace?.original,
                data?.workplace?.arabic,
              )}
            </div>
          ) : (
            <Link
              to={`${path.organization.ORGANIZATION_DETAILS_URI}/${data?.workplace?.id}`}
            >
              {checkTranslated(
                data?.workplace?.original,
                data?.workplace?.arabic,
              )}
            </Link>
          )}
        </div>
      ),
    },
    {
      name: 'division',
      header: _t('basic:division'),
      defaultFlex: 2,
      render: ({ data }: any) => (
        <div className="actionsCell">
          {data?.divisions?.length ? (
            isReport ? (
              <div className="flex-wrap hide-last">
                {data?.divisions.slice(0, 5).map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      {checkTranslated(item?.original, item?.arabic).length > 10
                        ? `${checkTranslated(
                            item?.original,
                            item?.arabic,
                          ).slice(0, 10)}...`
                        : checkTranslated(item?.original, item?.arabic)}
                      <span> , </span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <ItemPopperCell
                item={checkTranslated(
                  data?.divisions?.[0]?.original,
                  data?.divisions?.[0]?.arabic,
                )}
                data={data.divisions?.map((item: any) => ({
                  name: checkTranslated(item?.original, item?.arabic),
                }))}
                smallPopper
              />
            )
          ) : (
            '-'
          )}
        </div>
      ),
    },
    {
      name: 'duration',
      sortable: isReport ? false : true,
      header: _t('basic:duration'),
      defaultFlex: 2,
      render: ({ data }: any) => (
        <p className="createdOn">
          {data?.duration > 0 ? `${data?.duration} ${_t('basic:month')}` : '-'}
        </p>
      ),
    },
    ...commonColumns.slice(3, 4),
  ];
  const fellowStudentsColumns: TColumns[] = [
    ...commonColumns.slice(0, 1),
    {
      name: 'organization',
      header: _t('influencers:school_university'),
      defaultFlex: 2,
      render: ({ data }: any) => (
        <div className="actionsCell">
          {isReport ? (
            <div>
              {checkTranslated(
                data?.organization?.original,
                data?.organization?.arabic,
              )}
            </div>
          ) : (
            <Link
              to={`${path.organization.ORGANIZATION_DETAILS_URI}/${data?.organization?.id}`}
            >
              {checkTranslated(
                data?.organization?.original,
                data?.organization?.arabic,
              )}
            </Link>
          )}
        </div>
      ),
    },
    {
      name: 'division',
      header: _t('basic:division'),
      defaultFlex: 2,
      render: ({ data }: any) => (
        <div className="actionsCell">
          {data?.divisions?.length ? (
            isReport ? (
              <div className="flex-wrap hide-last">
                {data?.divisions.slice(0, 5).map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      {checkTranslated(item?.original, item?.arabic).length > 10
                        ? `${checkTranslated(
                            item?.original,
                            item?.arabic,
                          ).slice(0, 10)}...`
                        : checkTranslated(item?.original, item?.arabic)}
                      <span> , </span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <ItemPopperCell
                item={checkTranslated(
                  data?.divisions?.[0]?.original,
                  data?.divisions?.[0]?.arabic,
                )}
                data={data.divisions?.map((item: any) => ({
                  name: checkTranslated(item?.original, item?.arabic),
                }))}
                smallPopper
              />
            )
          ) : (
            '-'
          )}
        </div>
      ),
    },
    {
      name: 'duration',
      sortable: isReport ? false : true,
      header: _t('basic:duration'),
      defaultFlex: 2,
      render: ({ data }: any) => (
        <p className="createdOn">
          {data?.duration > 0 ? `${data?.duration} ${_t('basic:month')}` : '-'}
        </p>
      ),
    },
    ...commonColumns.slice(3, 4),
  ];

  const mentionsColumns: TColumns[] = [
    ...commonColumns.slice(0, 2),
    ...commonColumns.slice(3, 6),
  ];

  const allInitialFilters: TInitialFilters = {
    influencer_name: null,
    platform_ids: null,
    relation_ids: null,
    start_date: null,
    end_date: null,
    organization_name: null,
  };

  const InfluencerRelatedInfluencersTabsNames: TTabsNames = [
    { name: _t('basic:all'), key: 'all' },
    { name: _t('influencers:relatives'), key: 'relatives' },
    { name: _t('influencers:friends'), key: 'friends' },
    { name: _t('influencers:coworkers'), key: 'coworkers' },
    { name: _t('influencers:fellow_students'), key: 'fellow_students' },
    { name: _t('basic:mentions'), key: 'mentions' },
  ];

  const InfluencerRelatedInfluencersTabs: TTabs[] = [
    {
      tabName: _t('basic:all'),
      key: 'all',
      columns: allColumns,
      moduleName: influencerApiRoutes().allRelatedInfluencers,
      initialFiltersValues: allInitialFilters,
      initialFilters: allFiltersInputs,
      bulkActionOpts: [],
    },
    {
      tabName: _t('influencers:relatives'),
      key: 'relatives',
      columns: relativesColumns,
      moduleName: influencerApiRoutes().relativesRelatedInfluencers,
      initialFiltersValues: allInitialFilters,
      initialFilters: relativesFiltersInputs,
      bulkActionOpts: [],
    },
    {
      tabName: _t('influencers:friends'),
      key: 'friends',
      columns: friendsColumns,
      moduleName: influencerApiRoutes().friendsRelatedInfluencers,
      initialFiltersValues: allInitialFilters,
      initialFilters: friendsFiltersInputs,
      bulkActionOpts: [],
    },
    {
      tabName: _t('influencers:coworkers'),
      key: 'coworkers',
      columns: coworkersColumns,
      moduleName: influencerApiRoutes().coworkersRelatedInfluencers,
      initialFiltersValues: allInitialFilters,
      initialFilters: coworkersFiltersInputs,
      bulkActionOpts: [],
    },
    {
      tabName: _t('influencers:fellow_students'),
      key: 'fellow_students',
      columns: fellowStudentsColumns,
      moduleName: influencerApiRoutes().fellowStudentsInfluencers,
      initialFiltersValues: allInitialFilters,
      initialFilters: fellowStudentsFiltersInputs,
      bulkActionOpts: [],
    },
    {
      tabName: _t('basic:mentions'),
      key: 'mentions',
      columns: mentionsColumns,
      moduleName: influencerApiRoutes().mentionsRelatedInfluencers,
      initialFiltersValues: allInitialFilters,
      initialFilters: mentionsFiltersInputs,
      bulkActionOpts: [],
    },
  ];

  return {
    tabsNames: InfluencerRelatedInfluencersTabsNames,
    tabs: InfluencerRelatedInfluencersTabs,
    coworkersColumns: coworkersColumns,
    friendsColumns: friendsColumns,
    relativesColumns: relativesColumns,
    mentionsColumns: mentionsColumns,
    allColumns: allColumns,
    fellowStudents: fellowStudentsColumns,
  };
};
